import Definitions from "../../http_request/Model/Definitions/Definitions";
import {toast} from "react-toastify";

export const getFilterDetailsList = (setFilterDetailsList, setLoading) => {
    Definitions.request({
        beforeSend: () => {
            setLoading(true)
        },
        success: (data) => {
            let filterData = {}
            const convert = (value) => {

                return value.map((item) => {
                    return {'value': item, 'label': item}
                })
            }
            Object.entries(data)?.forEach(([key, value]) => {
                filterData = {...filterData, [key]: convert(value)}

            });
            setFilterDetailsList(filterData);
        },
        error: (error) => {
            toast.error(error?.message);
        },
        final: (data) => {
            setLoading(data);
        },
    }).FilterDetails();
};
